var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFeatureMarker),expression:"showFeatureMarker"}],staticClass:"feature-marker",style:({top:_vm.y+'px', left:_vm.x+'px'}),on:{"click":_vm.featureMarkerClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }